var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-box',[_c('a-title',{attrs:{"size":"4","text":_vm.label}}),_c('back-office-list',{staticClass:"has-word-break-all",attrs:{"list-data":_vm.value,"columns":_vm.casinoColumns,"selectable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }